// extracted by mini-css-extract-plugin
export default {"container":"toursPage_container__jcG42","content":"toursPage_content__q0bZP"};